import React from "react";

const items = [
  "Ceramic Coating",
  "Paint Correction",
  "Interior Deep Clean",
  "Full Detailing",
  "Engine Bay",
  "Headlight Restoration",
  "Leather Conditioning",
  "Clay Bar Treatment",
];

export default function StatsStrip() {
  return (
    <section
      data-testid="stats-strip"
      className="relative bg-red-500 text-black py-5 overflow-hidden border-y border-red-400"
    >
      <div className="flex whitespace-nowrap marquee">
        {[...items, ...items].map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-8 font-display text-xl uppercase tracking-tight"
          >
            <span className="w-2 h-2 bg-black rounded-full" />
            {it}
          </div>
        ))}
      </div>
    </section>
  );
}
